import { WeightPoundIcon } from './WeightPoundIcon';

/**
 * author: Haley Halcyon
 * id 47B5C7D8-105F-4420-B911-50693081EA76
 * name weight-pound
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/weight-pound.svg
 * tags
 */
export const WeightLbIcon = WeightPoundIcon;
export default WeightLbIcon